import { type AmsRefInput, AmsRefKind, KnowledgeGraphEntityType } from '../../api/graphql';

/** An AMS record by its AMS identity, as the AMS browser names it. */
export type AmsRef = {
  integrationId: string;
  kind: AmsRefKind;
  externalId: string;
  accountExternalId?: string | null;
};

/** The key a picked record is selected, deduplicated and rendered by. */
export const amsRefKey = (ref: AmsRef): string =>
  `${ref.integrationId}|${ref.kind}|${ref.externalId}`;

/** The ref as mutation input, without the response's __typename. */
export const amsRefInput = (ref: AmsRef): AmsRefInput => ({
  integrationId: ref.integrationId,
  kind: ref.kind,
  externalId: ref.externalId,
  accountExternalId: ref.accountExternalId ?? undefined
});

/** The entity type the picker's chips and icons are keyed by. */
export const entityTypeOfKind = (kind: AmsRefKind): KnowledgeGraphEntityType => {
  switch (kind) {
    case AmsRefKind.Account:
      return KnowledgeGraphEntityType.Account;
    case AmsRefKind.Policy:
      return KnowledgeGraphEntityType.Policy;
    case AmsRefKind.Certificate:
      return KnowledgeGraphEntityType.Certificate;
    case AmsRefKind.Activity:
      return KnowledgeGraphEntityType.Activity;
    case AmsRefKind.Folder:
    case AmsRefKind.File:
      return KnowledgeGraphEntityType.File;
  }
};
